import Header from '../../components/Header'
import { useTheme } from '../../contexts/ThemeContext'
import { motion } from 'framer-motion'
import 'primeicons/primeicons.css'

export default function ContactPage() {
  const { theme } = useTheme()

  const handleZaloContact = (phone: string) => {
    window.open(`https://zalo.me/${phone}`, '_blank')
  }

  const handlePhoneCall = (phone: string) => {
    window.location.href = `tel:${phone}`
  }

  return (
    <main className={`min-h-screen ${theme === 'dark' ? 'bg-black text-white' : 'bg-gray-50 text-gray-900'}`}>
      <Header />

      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="/images/homepage-background.png"
            alt="Contact background"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/70" />
        </div>

        <div className="relative z-10 py-20 text-center px-4">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-6xl font-extrabold text-gold-400 mb-4"
          >
            Liên hệ
          </motion.h1>
          <p className="max-w-2xl mx-auto text-gray-200">
            Liên hệ trực tiếp với Coach để đăng ký tập thử và được tư vấn miễn phí
          </p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="py-8 md:py-16 px-4">
        <div className="max-w-5xl mx-auto grid lg:grid-cols-2 gap-6 md:gap-8">
          {/* Liên hệ trực tiếp với Coach Nhật */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className={`rounded-2xl p-6 md:p-8 ${theme === 'dark' ? 'bg-gradient-to-br from-gold-900/30 to-black border-2 border-gold-500/40' : 'bg-gradient-to-br from-gold-50 to-white shadow-xl border-2 border-gold-400/40'}`}
          >
            <div className="text-center mb-6 md:mb-8">
              <div className="inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-gold-gradient mb-3 md:mb-4">
                <i className="pi pi-user text-2xl md:text-3xl text-black"></i>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold mb-2">Liên hệ với Coach Nhật</h2>
              <p className={`text-sm md:text-base ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                Đăng ký tập thử ngay hôm nay
              </p>
            </div>

            <div className="space-y-4 md:space-y-5 mb-6 md:mb-8">
              <div className={`p-5 md:p-6 rounded-xl ${theme === 'dark' ? 'bg-black/40 border border-gold-500/30' : 'bg-white/80 border border-gold-400/30'}`}>
                <div className="flex items-center gap-3 md:gap-4 mb-4">
                  <div className={`flex-shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center ${theme === 'dark' ? 'bg-gold-500/20' : 'bg-gold-400/20'}`}>
                    <i className="pi pi-phone text-gold-400 text-xl md:text-2xl"></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-bold text-lg md:text-xl break-all">0703 577 789</p>
                    <p className={`text-xs md:text-sm mt-1 ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>Coach Nhật</p>
                  </div>
                </div>
                <button
                  onClick={() => handlePhoneCall('0703577789')}
                  className={`w-full py-3.5 md:py-4 px-4 rounded-xl font-bold text-sm md:text-base transition active:scale-95 ${
                    theme === 'dark'
                      ? 'bg-gold-500/20 text-gold-400 hover:bg-gold-500/30 border-2 border-gold-500/50'
                      : 'bg-gold-400/20 text-gold-600 hover:bg-gold-400/30 border-2 border-gold-400/50'
                  }`}
                >
                  <i className="pi pi-phone mr-2 text-lg"></i>
                  Gọi ngay
                </button>
              </div>

              <div className={`p-5 md:p-6 rounded-xl ${theme === 'dark' ? 'bg-black/40 border border-gold-500/30' : 'bg-white/80 border border-gold-400/30'}`}>
                <p className={`text-sm md:text-base mb-4 font-semibold ${theme === 'dark' ? 'text-gray-200' : 'text-gray-800'}`}>
                  <i className="pi pi-info-circle text-gold-400 mr-2 text-lg"></i>
                  Liên hệ trực tiếp với Coach Nhật để:
                </p>
                <ul className={`space-y-3 text-sm md:text-base ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                  <li className="flex items-start gap-3">
                    <i className="pi pi-check-circle text-gold-400 mt-0.5 text-lg flex-shrink-0"></i>
                    <span>Đăng ký buổi tập thử miễn phí</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="pi pi-check-circle text-gold-400 mt-0.5 text-lg flex-shrink-0"></i>
                    <span>Tư vấn lộ trình tập luyện phù hợp</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="pi pi-check-circle text-gold-400 mt-0.5 text-lg flex-shrink-0"></i>
                    <span>Hỏi về lịch học và địa điểm</span>
                  </li>
                </ul>
              </div>
            </div>

            <button
              onClick={() => handleZaloContact('0703577789')}
              className="w-full py-4 md:py-5 rounded-xl bg-gold-gradient text-black font-bold text-base md:text-lg hover:scale-[1.02] active:scale-95 transition shadow-lg shadow-gold-500/30"
            >
              <i className="pi pi-send mr-2 text-lg"></i>
              Liên hệ ngay để đăng ký tập thử
            </button>
          </motion.div>

          {/* Liên hệ nhanh */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className={`rounded-2xl p-6 md:p-8 space-y-5 md:space-y-6 ${theme === 'dark' ? 'bg-gray-900 border border-gold-500/20' : 'bg-white shadow-xl'}`}
          >
            <h2 className="text-xl md:text-2xl font-bold">Liên hệ nhanh</h2>

            <div className="space-y-4 text-sm md:text-base">
              <div className={`flex items-center gap-3 p-3 md:p-4 rounded-lg ${theme === 'dark' ? 'bg-black/30' : 'bg-gray-50'}`}>
                <div className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center ${theme === 'dark' ? 'bg-gold-500/20' : 'bg-gold-400/20'}`}>
                  <i className="pi pi-phone text-gold-400 text-lg md:text-xl" />
                </div>
                <div className="flex-1 min-w-0">
                  <button onClick={() => handleZaloContact('0976950338')} className={`hover:text-gold-400 transition font-semibold text-sm md:text-base ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                    0976 950 338
                  </button>
                  <p className={`text-xs md:text-sm mt-1 ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>Coach Khang</p>
                </div>
              </div>
              <div className={`flex items-center gap-3 p-3 md:p-4 rounded-lg ${theme === 'dark' ? 'bg-black/30' : 'bg-gray-50'}`}>
                <div className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center ${theme === 'dark' ? 'bg-gold-500/20' : 'bg-gold-400/20'}`}>
                  <i className="pi pi-phone text-gold-400 text-lg md:text-xl" />
                </div>
                <div className="flex-1 min-w-0">
                  <button onClick={() => handleZaloContact('0703577789')} className={`hover:text-gold-400 transition font-semibold text-sm md:text-base ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                    0703 577 789
                  </button>
                  <p className={`text-xs md:text-sm mt-1 ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>Coach Nhật</p>
                </div>
              </div>
              <div className={`flex items-start gap-3 p-3 md:p-4 rounded-lg ${theme === 'dark' ? 'bg-black/30' : 'bg-gray-50'}`}>
                <div className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center ${theme === 'dark' ? 'bg-gold-500/20' : 'bg-gold-400/20'}`}>
                  <i className="pi pi-map-marker text-gold-400 text-lg md:text-xl" />
                </div>
                <div>
                  <p className="font-semibold text-sm md:text-base">Tân Bình</p>
                  <p className={`text-xs md:text-sm mt-1 ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>18D Cộng Hoà, P.4</p>
                </div>
              </div>
              <div className={`flex items-start gap-3 p-3 md:p-4 rounded-lg ${theme === 'dark' ? 'bg-black/30' : 'bg-gray-50'}`}>
                <div className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center ${theme === 'dark' ? 'bg-gold-500/20' : 'bg-gold-400/20'}`}>
                  <i className="pi pi-map-marker text-gold-400 text-lg md:text-xl" />
                </div>
                <div>
                  <p className="font-semibold text-sm md:text-base">Tân Phú</p>
                  <p className={`text-xs md:text-sm mt-1 ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>15/12/2 Cầu Xéo</p>
                </div>
              </div>
            </div>

            <div className={`pt-5 md:pt-6 border-t ${theme === 'dark' ? 'border-gold-500/20' : 'border-gray-200'}`}>
              <button
                onClick={() => handleZaloContact('0703577789')}
                className="w-full py-3.5 md:py-4 rounded-xl bg-blue-600 text-white font-bold text-sm md:text-base hover:bg-blue-700 transition active:scale-95"
              >
                <i className="pi pi-send mr-2 text-lg"></i>
                Chat Zalo với Coach Nhật
              </button>
            </div>
          </motion.div>
        </div>
      </section>
    </main>
  )
}
